<template>
  <div class="gmain" id="main">
    <div
      v-if="hebSen"
    >
      <div class="audio-container">
        <AudioBtn
          :urlId="audioSrc"
          :autoplay="autoPlay && win"
          :idx="idx"
          :display="win"
        />
      </div>
      <h2
        :class="{ flipX: rightNum === senLength + 1 }"
      >
        {{ hebSen.words }}
      </h2>
    </div>
    <div class="ansCon">
      <div class="lines" v-bind:style="{}" v-if="rightAnswers">
        <div
          v-for="(eword, idx) in rightAnswers"
          :key="idx"
          class="eanswer wrap"
        >
          <span class="ansText">{{ eword.words }}</span>
        </div>
      </div>
    </div>
    <div class="wordsContainer">
      <div
        v-for="(eword, idx) in allWords"
        :key="idx"
        class="eword shrink-on-active"
        :class="{
          ewordFinish: rightNum === senLength + 1,
          ewordSuccess: rightAnswers.includes(eword),
          ewordNo: notAnswers.includes(eword),
          ewordFailed: wrongAnswers.includes(eword)
        }"
        @click="checkWord(eword, $event)"
      >
        <EwordBtn
          :word="eword"
          :rightWords="rightAnswer"
          :autoPlay="autoPlay"
        ></EwordBtn>
      </div>
    </div>
    <div class="actions-wrapper" v-if="win">
      <button class="winBtn" @click="nextGame">
        {{ $t("engGame.eng.continue") }}
      </button>
    </div>
    <div :style="safeBottomVar" class="safeMargin"></div>
  </div>
</template>

<script>
import "./eng.scss";
// import confetti from "canvas-confetti";
import EngHeader from "./eng-header.vue";
import EwordBtn from "./ewordBtn.vue";
import AudioBtn from "../Shared/audioBtn.vue";
import { settingsService } from "../../services/settingsService";
import { Haptics, ImpactStyle } from "@capacitor/haptics";

export default {
  name: "EngGame",
  props: {
    data: {
      type: Array,
      default: () => []
    },
    gamedata: {
      type: String,
      default: () => {}
    },
    articleId: {
      type: String,
      default: ""
    },
    setFail: {
      type: Function,
      default: () => {}
    },
    setWin: {
      type: Function,
      default: () => {}
    },
    sennum: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      rightNum: 1,
      lost: 0,
      wrongSound: 1,
      rightAnswers: [],
      rightAnswer: null,
      notAnswers: [],
      wrongAnswers: [],
      allWords: [],
      gameid: null,
      noSound: false,
      isLoadedAudio: false,
      audioSrc: "",
      answerLock: false,
      isSound: true,
      autoPlay: true,
      soundSetting: null,
      win: false,
      wrongAudioSrc: null,
      wrong2AudioSrc: null,
      playing: false,
    };
  },
  computed: {
    engWords() {
      const wordsList = this.data;
      return wordsList
        .filter(res => res.order > 0)
        .sort((a, b) => {
          return a.order < b.order ? -1 : 1;
        });
    },
    // engSen() {
    //   if (this.engWords) return this.engWords.map(w => w.words).join(" ");
    // },
    whoHa() {
      return this.engWords.map(res => {
        return new Array(res.words.length + 1).join("*");
      });
    },
    senLength() {
      const wordsList = this.data;
      return wordsList.filter(res => res.order > 0).length;
    },
    allEngWords() {
      const wordsList = this.data;
      return wordsList.filter(res => res.order !== 0);
    },
    totalWords() {
      return this.engWords.length;
    },
    hebSen() {
      return this.data.find(res => res.order === 0);
    },
    otherWords() {
      return this.data.filter(o => o.order == -1);
    },
    safeBottomVar() {
      return { "--bottom": this.$store.getters.safeBottom + "px" };
    }
  },
  created() {
    this.gameid = this.$route.params.id;
    console.log(this.data);
  },
  watch: {
    data() {
      if (this.allEngWords) this.allWords = this.shuffle(this.allEngWords);
      this.isLoadedAudio = false;
      this.getAudio();
    },
    sennum() {
      this.rightAnswers.splice(0);
      this.notAnswers.splice(0);
      this.wrongAnswers.splice(0);
      this.lost = 0;
      this.rightNum = 1;
    },
    soundSetting() {
      console.log(this.soundSetting);
      if (this.soundSetting && this.soundSetting.length) {
        console.log("SOUND SETTINGS", this.soundSetting);
        this.isSound = this.soundSetting[0];
        this.autoPlay = this.soundSetting[1];
      }
    }
  },
  async mounted() {
    if (this.allEngWords) this.allWords = this.shuffle(this.allEngWords);
    this.win = false;
    this.getAudio();
    this.wrongSound = 1;
    this.wrongAudioSrc = new Audio(require("../../assets/audio/LOSS1.mp3"));
    this.wrong2AudioSrc = new Audio(require("../../assets/audio/LOSS2.mp3"));
    this.soundSetting = await settingsService.getSettings();
  },
  beforeDestroy() {
    this.audioSrc = "";
    this.isLoadedAudio = false;
  },
  //   watch: {
  //     allEngWords() {
  //       this.allWords = this.shuffle(this.allEngWords);
  //     }
  //   },
  methods: {
    nextGame() {
      this.win = false;
      this.setWin();
    },
    capitalize(word) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    },

    shuffle(array) {
      return [...array].sort(() => Math.random() - 0.5);
    },
    async checkWord(word, event) {
      if (this.answerLock) return;
      if (this.rightNum > this.senLength) return;
      if (word.order === this.rightNum) {
        if (this.wrongAnswers.includes(word)) {
          const index = this.wrongAnswers.indexOf(word);
          const x = this.wrongAnswers.splice(index, 1);
        }
        if (this.rightNum === 1) word.words = this.capitalize(word.words);
        this.rightAnswers.push(word);
        this.rightAnswer = word;
        if (window.navigator && window.navigator.vibrate)
          window.navigator.vibrate(100);
        const btnX = event.clientX / window.innerWidth;
        const btnY = event.clientY / window.innerHeight;

        // confetti({
        //   particleCount: 5,
        //   spread: 15,
        //   origin: { y: btnY, x: btnX },
        //   ticks: 100
        // });
        if (this.rightNum === this.senLength) {
          setTimeout(() => {
            this.win = true;
            }, "1000");
        }
        this.rightNum = this.rightNum + 1;
      }
      if (word.order > this.rightNum) {
        this.answerLock = true;
        setTimeout(() => {
          this.answerLock = false;
        }, "500");
        this.playWrong();

        if (!this.wrongAnswers.includes(word)) this.wrongAnswers.push(word);
        this.lost = this.lost + 1;
        this.setFail(word, this.rightNum, this.engWords, this.hebSen.words);
        if (this.lost === 3) console.log("Failed!");
      }
      if (word.order == -1) {
        this.answerLock = true;
        setTimeout(() => {
          this.answerLock = false;
        }, "500");
        this.playWrong();
        this.notAnswers.push(word);
        this.lost = this.lost + 1;
        this.setFail(word, this.rightNum, this.engWords, this.hebSen.words);
        if (this.lost === 3) console.log("Failed!");
      }
    },
    getAudio() {
      this.isLoadedAudio = false;
      this.audioSrc = `${localStorage.getItem("destLocale")}_${this.articleId}_${this.sennum}_full`
    },
    playWrong() {
      if (this.isSound) {
        if (this.wrongSound % 2) this.wrongAudioSrc.play();
        else this.wrong2AudioSrc.play();
        this.wrongSound = this.wrongSound + 1;
      }
    },
  },
  components: { EngHeader, EwordBtn, AudioBtn }
};
</script>

<style scoped>
h2 {
  font: var(--large-font);
  line-height: 1.5;
  padding: 0 32px;
  text-wrap: balance;
  margin-top: 24px;
  color: var(--button-primary);
}

.gmain {
  flex-grow: 1;
  height: calc(100vh - 40vh);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.ewordFinish {
  background-color: var(--bg-primary);
  border-color: var(--color-disabled);
  box-shadow: 0px 0px var(--color-disabled);
  color: var(--color-disabled);
}

.ewordSuccess {
  transition: background-color 1s ease-out;
  border: 2px solid var(--success-primary);
  background-color: var(--success-primary);
  color: var(--success-secondary);
  box-shadow: none;
  pointer-events: none;
}

.ewordFailed {
  transition: background-color 1s ease-out;
  color: var(--warning-secondary);
  background-color: var(--warning-primary);
  border: 2px solid var(--warning-secondary);
  box-shadow: 0 4px 4px var(--warning-secondary);
}

.ewordNo {
  transition: background-color 1s ease-out;
  border: 2px solid var(--error-primary);
  background-color: var(--error-primary);
  color: var(--bg-primary);
  box-shadow: none;
  pointer-events: none;
}

.wordsContainer {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;
}

.ansCon {
  min-height: 142px;
  width: 100%;
}

.lines {
  direction: var(--dest-direction);
  font: var(--huge-font);
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  align-content: flex-start;
  margin: 20px 32px 4rem;
  background: repeating-linear-gradient(
    to bottom,
    transparent 0,
    transparent 32px,
    var(--bubble-primary) 32px,
    var(--bubble-primary) 32px,
    transparent 34px,
    transparent 34px
  );
  min-height: 100px;
}

.wrap {
  padding-bottom: 2px;
  padding-top: 2px;
  line-height: 1;
}

.ansText {
  margin-right: 6px;
  font: var(--medium-font);
  color: var(--header-primary);
}

.transWord {
  color: transparent;
  flex-grow: 1000;
}

.actions-wrapper {
  height: 100px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.audio-container {
  text-align: center;
  height: 50px;
}

.winBtn {
  background-color: var(--button-primary);
  color: var(--button-primary-text);
  font: var(--large-font);
  width: 100%;
  height: 100%;
  display: grid;
  padding: 30px;
}

.flipX {
  animation: 2s anim-flipX ease 1;
}

@keyframes anim-flipX {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }

  40% {
    transform: translateY(-30px);
  }

  60% {
    transform: translateY(-15px);
  }
}

/* .eanswer {
  text-decoration: underline;
}
.answersContainer {
  display: flex;
  gap: 4px;
  direction: ltr;
}
.lines {
  width: 50%;
  display: flex;
  flex-flow: row wrap;
  align-items: stretch;
}
.wordCon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  border-bottom: 1px solid red;
  padding: 10px;
} */
.safeMargin {
  margin-bottom: var(--bottom);
}
</style>



// WEBPACK FOOTER //
// eng.vue?d99ed636